jQuery(document).ready(function ($) {
  MktoForms2.loadForm(
    "//go.mybudget.com.au",
    "253-OAJ-725",
    1144,
    function (marketoForm) {
      // Check if the current page is subscribe landing page
      // If it is the subscribe landing page, some element IDs , classes and
      // messages will be different from the regular newsletter subsription form
      const userDataKey = "mbUser";
      var mbUserData = new Map(JSON.parse(localStorage.getItem(userDataKey)));

      var newsletterWrapper = $(
        ".mb-newsletter-section, .mb_blog_newsletter, .mb-podcast-newsletter-section"
      );
      var newsletterBlogWrapper = $(".mb-blog-newsletter-section");

      var form = $(".mb-newsletter-form");
      form.data("submitted", false);

      form.find("input[type='text']").val("");

      var beforeMessage = $(".mb-newsletter-before-wrapper");
      var headingText = $(".mb-newsletter-heading");
      var subheadingText = $(".mb-newsletter-text");
      var formInputs = $(".mb-input-wrapper");
      var hasValidFName = false;
      var hasValidEmail = false;

      var firstNameText = form.find('input[name="newsletterFName"]');
      var emailText = form.find('input[name="newsletterEmail"]');
      var formType = form.find('input[id="formType"]');

      var submitBtn = form.find('input[type="submit"]');
      var submitBtnWrapper = $(".mb-submit-wrapper");
      // Error Labels
      var firstNameError = form.find("#newsletterFNameError");
      var emailError = form.find("#newsletterEmailError");

      var typingTimerFName;
      var typingTimerEmail;

      var typingInterval = 200;

      prePopulateForm();

      // Display Logic
      var subscribedToNewsletter = localStorage.getItem(
        "mb_newsletter_subscribed"
      );
      newsletterWrapper.hide();
      if (
        subscribedToNewsletter === null ||
        JSON.parse(subscribedToNewsletter) === false
      ) {
        newsletterWrapper.show();
        localStorage.setItem("mb_newsletter_subscribed", false);
      }

      // START OF FORM ABANDONMENT

      let interactedWithTheForm = false;
      let lastInteractedField = "";

      form.on("input", (e) => {
        if (!interactedWithTheForm) {
          interactedWithTheForm = true;
        }
        lastInteractedField = $(e.target).attr("id");
      });

      $(window).on("beforeunload", () => {
        if (!form.data("submitted") && interactedWithTheForm) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "newsletter_form_abandonment",
            mb_last_interacted_field: lastInteractedField,
            mb_newsletter_form_type: formType.val(),
          });
        }
      });
      // END OF FORM ABANDONMENT

      submitBtn.click(function (event) {
        validateAllFields();
        if (isFormValid() && form.data("submitted") != true) {
          setUserData();
          submitBtn.prop("disabled", true);
          submitBtnWrapper.addClass("newletter-submit-btn-load");
          submitBtnWrapper.fadeTo("slow", 0.5, function () {
            submitBtn.val("Please Wait");
            formInputs.fadeTo("slow", 0.2);
            $(".mb-newsletter-text-wrapper").fadeTo("slow", 0.5);
          });
          form.submit();
        } else {
          form.data("submitted", false);
          event.preventDefault();
          event.returnValue = false;
        }
      });

      form.submit(function (event) {
        // Mark it so that the next submit can be ignored
        form.data("submitted", true);

        hasValidFName = false;
        hasValidEmail = false;
        event.preventDefault();
        event.returnValue = false;

        var newsletterFirstName = firstNameText.val();
        var newsletterEmail = emailText.val();

        marketoForm.addHiddenFields({
          Email: newsletterEmail,
          FirstName: newsletterFirstName,
          subscriptionNewsletter: true,
        });
        marketoForm.submit();
        marketoForm.onSuccess(function (values, followUpUrl) {
          dataLayer.push({
            event: "subscribe_newsletter",
            mb_newsletter_form_type: formType.val(),
          });
          newsletterBlogWrapper.hide();

          formInputs.animate({ opacity: 0 }, 400);
          submitBtnWrapper.animate({ opacity: 0 }, 200, function () {
            submitBtnWrapper.removeClass("newletter-submit-btn-load");
            submitBtnWrapper.addClass("newletter-submit-btn-success");
            submitBtn.val("Subscribed");
          });

          $(".mb-newsletter-text-wrapper").animate(
            { opacity: 0 },
            400,
            function () {
              beforeMessage.addClass("newletter-before-wrapper-success");
              formInputs.hide();

              headingText.text(
                getSuccessHeadingText().replace("{FNAME}", newsletterFirstName)
              );
              subheadingText.html(
                getSuccessSubHeadingText().replace("{EMAIL}", newsletterEmail)
              );
              $(".mb-newsletter-text-wrapper").animate({ opacity: 1 }, 400);
              submitBtnWrapper.animate({ opacity: 1 }, 400);

              form.trigger("reset");

              // Scroll to welcome message if not visible
              var offset = headingText.offset().top;
              var visible_area_start = $(window).scrollTop() + 70;
              var visible_area_end =
                visible_area_start + window.innerHeight - 100;
              if (offset < visible_area_start || offset > visible_area_end) {
                // Not in view so scroll to it
                $("html,body").animate(
                  { scrollTop: offset - window.innerHeight / 3 },
                  1000
                );
              }
            }
          );
          localStorage.setItem("mb_newsletter_subscribed", true);
          return false;
        });
      });

      firstNameText.on("input", function () {
        clearTimeout(typingTimerFName);
        typingTimerFName = setTimeout(validateFirstName, typingInterval);
      });

      emailText.on("input", function () {
        clearTimeout(typingTimerEmail);
        typingTimerEmail = setTimeout(validateEmail, typingInterval);
      });
      function validateAllFields() {
        validateFirstName();
        validateEmail();
      }

      function getSuccessHeadingText() {
        return "Thank you for subscribing.";
      }

      function getSuccessSubHeadingText() {
        return "<b>{EMAIL}</b> will be sent the next issue of our newsletter shortly.";
      }

      firstNameText.focusout(function () {
        toggleFloatLabelClass(firstNameText);
        validateFirstName();
      });

      emailText.focusout(function () {
        toggleFloatLabelClass(emailText);
        validateEmail();
      });

      firstNameText.focusin(function () {
        $("label[for='" + firstNameText.attr("id") + "']").addClass(
          "float-label"
        );
        addFocusInClass(firstNameText);
      });

      emailText.focusin(function () {
        $("label[for='" + emailText.attr("id") + "']").addClass("float-label");
        addFocusInClass(emailText);
      });

      function validateFirstName() {
        if (!firstNameText.val()) {
          firstNameError.html("You must enter a valid first name to proceed");
          addFieldErrorClass(firstNameText);
        } else {
          hasValidFName = isValidName(firstNameText.val());
          if (hasValidFName) {
            firstNameError.html("");
            addFocusOutClass(firstNameText);
          } else {
            firstNameError.html("Please provide a valid first name");
            addFieldErrorClass(firstNameText);
          }
        }
      }

      function validateEmail() {
        if (!emailText.val()) {
          emailError.html(
            "You must enter a valid email address to proceed (e.g. email@email.com)"
          );
          addFieldErrorClass(emailText);
        } else {
          hasValidEmail = isValidEmail(emailText.val());
          if (hasValidEmail) {
            emailError.html("");
            addFocusOutClass(emailText);
          } else {
            emailError.html(
              "Please provide a valid email address e.g email@email.com"
            );
            addFieldErrorClass(emailText);
          }
        }
      }

      function isValidName(value) {
        if (/^[ a-zA-Z\-\’\']+$/.test(value.replace(/\s/g, ""))) {
          return true;
        } else {
          return false;
        }
      }

      function isValidEmail(value) {
        if (
          /^(([^<>()[\]\\.,`~#?$%|^{}&\/*!=;:'\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          )
        ) {
          return true;
        } else {
          return false;
        }
      }

      function isFormValid() {
        return hasValidFName && hasValidEmail;
      }

      function addFocusInClass(element) {
        element.addClass("fieldFocusIn");
        element.removeClass("fieldFocusOut");
        element.removeClass("fieldError");
      }
      function addFocusOutClass(element) {
        element.addClass("fieldFocusOut");
        element.removeClass("fieldFocusIn");
        element.removeClass("fieldError");
      }
      function addFieldErrorClass(element) {
        element.addClass("fieldError");
        element.removeClass("fieldFocusIn");
        element.removeClass("fieldFocusIn");
      }

      function toggleFloatLabelClass(inputElement) {
        var label = $("label[for='" + inputElement.attr("id") + "']");
        if (!inputElement.val()) {
          label.removeClass("float-label");
        } else {
          label.addClass("float-label");
        }
      }

      function setUserData() {
        if (firstNameText.val()) mbUserData.set("fName", firstNameText.val());
        if (emailText.val()) mbUserData.set("email", emailText.val());
        localStorage.setItem(
          userDataKey,
          JSON.stringify(Array.from(mbUserData.entries()))
        );
      }

      function prePopulateForm() {
        if (
          mbUserData !== null &&
          mbUserData.get("fName") &&
          mbUserData.get("email")
        ) {
          firstNameText.val(mbUserData.get("fName"));
          emailText.val(mbUserData.get("email"));
          toggleFloatLabelClass(firstNameText);
          toggleFloatLabelClass(emailText);
        }
      }
    }
  );
});
